/** @file 用户管理相关接口 */
import ajax from '@/utils/ajax.js'

const PUBLIC_KEY = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCKqPCl9vgnzEQGwUCT4EIvpC
5/DJlzawy4U+VqqKdXEbMOQKp2lpcyOlbt4qT3sBJKPjY7c8MdMKSlq+fm32KSiV5w8
Cxna1lMqZtTaaj4saSXqabY188NVt7TVi98vTR+yjBWJtgwmMbN7D93wpsi7u9
QoeFCF+09OG/gXEW6+QIDAQAB`

export const getUserInfo = async () => {
  const res = await ajax.get('/webapi/user-center/v1/session/get')
  return res
}

// 密码登录
export const login = async (params) => {
  // eslint-disable-next-line no-undef
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----')
  params.cipher = encrypt.encrypt(params.cipher)
  // 后端实现问题，登录和验证码暂时做下特殊处理，不把网关域名打包进代码里面
  const res = await ajax.post('/webapi/user-center/v1/n/login', { params })
  return res
}

// 获取用户默认企业身份
export const getCompanyInfo = async () => {
  const res = await ajax.get('/webapi/user-center/v1/session/get')
  return res
}

// 获取我的产品列表
export const getAppInfo = async () => {
  const res = await ajax.get('/webapi/user-center/v1/app/list')
  return res
}

// 获取用户所属的企业列表
export const getCompanyList = async () => {
  const res = await ajax.get('/webapi/user-center/v1/ent/list')
  return res
}

// 切换企业
export const selectCompany = async (params) => {
  const res = await ajax.post('/webapi/user-center/v1/session/ent/login', { params })
  return res
}

// 短信验证码登录-获取短信验证码
export const loginSendCode = async (params) => {
  const res = await ajax.get('/webapi/user-center/v1/n/sms', { params })
  return res
}
// 短信验证码登录-登录
export const loginByCode = async (params) => {
  const res = await ajax.post('/webapi/user-center/v1/n/phone/login', { params })
  return res
}

// 忘记密码
export const resetPwdSendCode = async (params) => {
  const res = await ajax.post('/webapi/platform-user-center/platform/v1/password-reset/code', { params })
  return res
}

// 重置密码
export const resetPwdConfirm = async (data) => {
  // eslint-disable-next-line no-undef
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----')
  data.password = encrypt.encrypt(data.password)
  const res = await ajax.post('/webapi/platform-user-center/platform/v1/password-reset/confirm', { data })
  return res
}

// 用户跳转权限
export const checkLogin = async (params) => {
  const res = await ajax.post('/webapi/user-center/v1/session/app/access', { params })
  return res
}

// 检查企业是否认证
export const checkEntAuth = async () => {
  const res = await ajax.get('/webapi/user-center/v1/session/ent', {
    toastError: false
  })
  return res
}

// 获取企业认证链接
export const getAuthLink = async () => {
  const res = await ajax.get('/webapi/system/v1/ent/auth')
  return res
}

export const getPasswordCodeSrc = async () => {
  const response = await ajax.get('/webapi/user-center/v1/n/graphic', {
    responseType: 'blob'
  })
  const src = URL.createObjectURL(response.data)
  return src
}

// 获取应用信息根据code
export const getAppInfoByCode = async (params) => {
  const res = await ajax.get('/webapi/system/v2/app/get', { params, toastError: false })
  return res
}

// 退出登录
export const logOut = async () => {
  const res = await ajax.post('/webapi/user-center/v1/logout', {
    ifResponseOrigin: true
  })
  return res
}

// 获取当前账号员工信息
export const getUserStaffInfo = async () => {
  const res = await ajax.get('/webapi/ent-org-management/v1/staff/my')
  return res
}

// 获取当前账号权限
export const getUserPermissions = async () => {
  const res = await ajax.get('/webapi/user-center/v1/permissions')
  return res
}
